import { type ReactNode } from 'react';
import { imageGetters } from '../../helpers/imageGetters';
import styles from './AppInfo.module.css';

interface AppInfoProps {
  title: ReactNode;
  subtitle: ReactNode;
}

export function AppInfo(props: AppInfoProps) {
  const { title, subtitle } = props;

  return (
    <div className={styles.root}>
      <img className={styles.icon} src={imageGetters.pwaLogo56()} width={56} height={56} alt="" />
      <div className={styles.texts}>
        <h1 className={styles.title}>{title}</h1>
        <h2 className={styles.subtitle}>{subtitle}</h2>
      </div>
    </div>
  );
}
